/** Storage data structure */
export interface Storage {
  theme: 'light' | 'dark'
}

/** Default storage values */
export const defaults: Readonly<Storage> = {
  theme: 'light',
}

export const storage = {
  defaults,

  /**
   * Retrieve a value from the local storage
   * @param key The key to retrieve
   * @returns The value if found in the storage, otherwise returns its default value
   */
  get: <T extends keyof Storage>(key: T): Storage[T] => {
    const storedValue = localStorage.getItem(key)
    if (storedValue) return JSON.parse(storedValue) as Storage[T]
    return defaults[key]
  },

  /**
   * Store a value in the local storage
   * @param key The key to store to
   * @param value The value to store
   */
  set: <T extends keyof Storage>(key: T, value: Storage[T]) =>
    localStorage.setItem(key, JSON.stringify(value)),

  /**
   * Remove a value from the local storage
   * @param key The key to remove
   */
  remove: (key: keyof Storage) => localStorage.removeItem(key),

  /** Clears the local storage */
  clear: () => localStorage.clear(),
}

export default storage
